export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
export const NB_HELP_IN_SEARCH = 'newbuilding_consultant_help_in_search';
export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';
export const PERSONAL_RANKING = 'aud_desktop_cd178510_ranking_v3';
export const WEB_3D_TOURS_EXPERIMENT = 'b2b_3d_tours_web';
export const FILTERS_REDESIGN_EXPERIMENT = 'sub_desktop_hom_743_filter_redesign';

export const EXPERIMENTS: string[] = [
  'newbuilding_consultant',
  NB_CHAT_COMMON_FILTER,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
  NB_HELP_IN_SEARCH,
  RENTER_FORM_EXPERIMENT,
  PERSONAL_RANKING,
  WEB_3D_TOURS_EXPERIMENT,
  FILTERS_REDESIGN_EXPERIMENT,
];
